module.exports = __webpack_public_path__ + "img/googlechrome.b4002e70.png";